
/**
 * 动画入场类型
 */
export const TYPE_ZOOM_IN = "module_zoom_in";

/**
 * 视频类型
 */
export const TYPE_VIDEO = "module_video";

/**
 * tab选项卡类型
 */
export const TYPE_TABDATA = "module_tab";

/**
 * banner类型
 */
export const TYPE_BANNERDATA = "module_banner";

/**
 * 品牌列表类型
 */
export const TYPE_BRANDS = "module_brands";

/**
 * 跳转类型 - APP
 */
export const TYPE_JUMP_APP = "jump_app";

/**
 * 跳转类型 - 小程序
 */
export const TYPE_JUMP_WEAPP = "jump_weapp";

/**
 * 跳转类型 - 网页
 */
export const TYPE_JUMP_WEB = "jump_web";

/**
 * 跳转类型 - 显示弹窗
 */
export const TYPE_JUMP_POPUP = "jump_popup";

/**
 * 动画类型 - 普通缩放入场
 */
export const TYPE_ANIMTAION_NORMAL = "animation_normal";

/**
 * 动画类型 - 从上一个元素位置旋转入场
 */
export const TYPE_ANIMATION_SPIRAL = "animation_spiral";
